
  document.addEventListener("DOMContentLoaded", function() {
    // Función para verificar la existencia de los bundles y ocultar los textos
    function checkBundlesAndHideTexts() {
      var bundlerProduct = document.querySelector('.bndlr-product');

      // Busca todos los párrafos con la clase 'product__text'
      var productTexts = document.querySelectorAll("p.product__text");

      // Oculta o muestra los textos basándose en la existencia de bundles
      if (bundlerProduct) {
        console.log("Clase 'bndlr-product' encontrada. Mostrando los textos.");
        productTexts.forEach(function(text) {
          if (text.textContent.includes("AHORRA CON ESTOS PACKS") || 
              text.textContent.includes("Los descuentos se aplican en el checkout.")) {
            text.style.display = "block"; // Asegúrate de que se muestren
          }
        });
      } else {
        console.log("Clase 'bndlr-product' no encontrada, ocultando los textos.");
        productTexts.forEach(function(text) {
          if (text.textContent.includes("AHORRA CON ESTOS PACKS") || 
              text.textContent.includes("Los descuentos se aplican en el checkout.")) {
            text.style.display = "none"; // Oculta los textos
          }
        });
      }
    }

    // Crear un observador de mutaciones
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          checkBundlesAndHideTexts(); // Verificar cada vez que se añadan nodos
        }
      });
    });

    // Configura el observador para observar cambios en el cuerpo
    observer.observe(document.body, {
      childList: true,
      subtree: true // Para observar también cambios en los hijos
    });

    // Llamar a la función inicial para verificar los bundles al cargar
    checkBundlesAndHideTexts();
  });
